module.exports = __webpack_public_path__ + "static/img/envelope-top-optimized.ca8bf4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelope-top-optimized.png
// module id = 563
// module chunks = 1